module.exports = __webpack_public_path__ + "static/img/point_2.67ab0694.png";